import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PermissionChecker } from '../../session'
import { accountsClient } from '../../../utils/apollo/api'
import { useLocalStorageWatcher } from '../../../utils/helpers/localStorage'
import AddNewButton from '../list/AddNewButton'
import ControlBar from '../list/ControlBar'
import Kanban from '../../../containers/screens/kanban/Kanban'
import ListCounter from '../../../components/helpers/ListCounter'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import PageHeader from '../list/PageHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SideMenuTemplate from '../../../components/templates/v2/SideMenuTemplate'
import UserCard from '../../../containers/users/UserCard'
import UsersLoader from './_load/UsersLoader'

const UsersKanbanPage = ({ id }) => {
  useLocalStorageWatcher('USERS_LAST_SCREEN', `kanban/${id}`)

  return (
    <SideMenuTemplate bgColor={COLORS.white}>
      <Separator weight={6} flex={1}>
        <PermissionChecker permission="listUser">
          <FilterHandler tempStorageNamespace="users" initialState={{}}>
            <MultiSelectHandler>
              <PageHeader />
              <ControlBar hideFastFilters selectedScreen={`kanban/${id}`} />
              <Kanban
                screenId={id}
                Loader={UsersLoader}
                Card={UserCard}
                Counter={props => (
                  <ListCounter
                    client={accountsClient}
                    entity="users"
                    filterName="UserFilter"
                    size="xsmall"
                    bold
                    {...props}
                  />
                )}
              />
            </MultiSelectHandler>
            <AddNewButton />
          </FilterHandler>
        </PermissionChecker>
      </Separator>
    </SideMenuTemplate>
  )
}

export default UsersKanbanPage
